import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";

const orgAppSettingsEndpoint = '/identity/OrgAppSettings';
const orgApiClient = new ApiClient();
orgApiClient.requiresAuth = false;

const useMyOrgAppInfo = (swrOptions = {}) => {
    const params = new URLSearchParams();
    return useGenericSWR(orgAppSettingsEndpoint + "?" + params.toString(), orgApiClient, { ...swrOptions });

};

export {
    useMyOrgAppInfo
};